(function() {
  var Controller, CropYear,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  CropYear = App.loadClass('core::CropYear');

  exports.SidebarController = (function(superClass) {
    extend(SidebarController, superClass);

    function SidebarController(scope, transitions, service, state, q, stateParams, http, timeout, modal, window) {
      this.scope = scope;
      this.transitions = transitions;
      this.service = service;
      this.state = state;
      this.q = q;
      this.stateParams = stateParams;
      this.http = http;
      this.timeout = timeout;
      this.modal = modal;
      this.window = window;
      this.createSummaryReport = bind(this.createSummaryReport, this);
      this.seeIfDisableSummaryReport = bind(this.seeIfDisableSummaryReport, this);
      this.exitSurvey = bind(this.exitSurvey, this);
      this.stepSaved = bind(this.stepSaved, this);
      this.stepVisited = bind(this.stepVisited, this);
      this.currentStepIs = bind(this.currentStepIs, this);
      this.inNSolverProcess = bind(this.inNSolverProcess, this);
      this.showFullpage = bind(this.showFullpage, this);
      this.gotoStep = bind(this.gotoStep, this);
      this.completeFieldSurveysForSurvey = bind(this.completeFieldSurveysForSurvey, this);
      this.incompleteSurveys = bind(this.incompleteSurveys, this);
      this.surveyExists = bind(this.surveyExists, this);
      this.firstIncompleteStepIndex = bind(this.firstIncompleteStepIndex, this);
      this.editSurvey = bind(this.editSurvey, this);
      this.startSurvey = bind(this.startSurvey, this);
      this.getSurveys = bind(this.getSurveys, this);
      SidebarController.__super__.constructor.apply(this, arguments);
      this.scope.show_fullpage = false;
      this.scope.show_fullpage_fn = this.showFullpage;
      this.scope.disableSummaryReportButton = true;
      this.scope.disableSummaryReportCheckbox = true;
      this.scope.summaryReportHistoricalData = false;
      this.scope.selected_options = {
        year: new CropYear().get(),
        crop: null
      };
      this.scope.service = this.service;
      this.scope.years = [];
      this.scope.crops = [];
      this.scope.surveys = [];
      if (this.service.saving) {
        this.service.saving.then(this.getSurveys);
      } else {
        this.getSurveys();
      }
      this.scope.createError = null;
      this.scope.startSurvey = this.startSurvey;
      this.scope.editSurvey = this.editSurvey;
      this.scope.firstIncompleteStepIndex = this.firstIncompleteStepIndex;
      this.scope.inNSolverProcess = this.inNSolverProcess;
      this.scope.gotoStep = this.gotoStep;
      this.scope.surveyExists = this.surveyExists;
      this.scope.incompleteSurveys = this.incompleteSurveys;
      this.scope.completeFieldSurveysForSurvey = this.completeFieldSurveysForSurvey;
      this.scope.exitSurvey = this.exitSurvey;
      this.scope.seeIfDisableSummaryReport = this.seeIfDisableSummaryReport;
      this.scope.createSummaryReport = this.createSummaryReport;
      this.scope.currentStepIs = this.currentStepIs;
      this.scope.stepVisited = this.stepVisited;
      this.scope.stepSaved = this.stepSaved;
      this.service.brandNew = false;
      this.service.reset();
      this.service.configLoaded.then((function(_this) {
        return function() {
          if (!_this.service.config.crops) {
            _this.state.go('grower.fields');
          }
          return _this.scope.crops = _this.service.config.crops;
        };
      })(this));
      this.http.get('api/crops').then((function(_this) {
        return function(response) {
          return _this.allCrops = response.data;
        };
      })(this));
    }

    SidebarController.prototype.getSurveys = function() {
      return this.http.get('api/nitrogen-surveys').then((function(_this) {
        return function(response) {
          var i, len, ref, survey, years;
          _this.scope.surveys = response.data;
          years = [];
          ref = _this.scope.surveys;
          for (i = 0, len = ref.length; i < len; i++) {
            survey = ref[i];
            years.push(survey.year);
          }
          years.push(new CropYear().get());
          years.push((new CropYear().get()) - 1);
          years = _.uniq(years).sort();
          return _this.scope.years = years;
        };
      })(this));
    };

    SidebarController.prototype.startSurvey = function() {
      var crop;
      crop = _.find(this.allCrops, {
        name: this.scope.selected_options.crop
      });
      this.service.reset();
      return this.service.createSurvey(this.scope.selected_options.year, crop.id).then((function(_this) {
        return function(response) {
          _this.scope.createError = null;
          _this.service.brandNew = true;
          _this.scope.surveys.push(response.data);
          return _this.service.gotoStep(0, response.data.id, false);
        };
      })(this))["catch"]((function(_this) {
        return function(error) {
          if (error.status === 422) {
            _this.scope.createError = error.data;
            return _this.timeout(function() {
              return _this.scope.createError = null;
            }, 5000);
          }
        };
      })(this));
    };

    SidebarController.prototype.editSurvey = function(survey) {
      var stepIndex;
      if (!survey) {
        survey = this.surveyExists();
      }
      this.service.reset();
      this.service.brandNew = false;
      this.service.year = survey.year;
      this.service.crop = survey.crop.name;
      this.service.survey = survey;
      stepIndex = this.firstIncompleteStepIndex(survey) || 0;
      return this.service.gotoStep(stepIndex, survey.id, false);
    };

    SidebarController.prototype.firstIncompleteStepIndex = function(survey) {
      var ref;
      if (survey == null) {
        survey = this.survey;
      }
      return (ref = _.find(this.service.config.steps, (function(_this) {
        return function(stepConfig, stepName) {
          return !_this.service.stepComplete(stepName, survey);
        };
      })(this))) != null ? ref.order : void 0;
    };

    SidebarController.prototype.surveyExists = function() {
      return _.find(this.scope.surveys, (function(_this) {
        return function(survey) {
          return survey.year === _this.scope.selected_options.year && survey.crop.name === _this.scope.selected_options.crop;
        };
      })(this));
    };

    SidebarController.prototype.incompleteSurveys = function(year) {
      return _.filter(this.scope.surveys, {
        year: year
      }).filter((function(_this) {
        return function(survey) {
          return !_this.service.surveyComplete(survey);
        };
      })(this));
    };

    SidebarController.prototype.completeFieldSurveysForSurvey = function(survey) {
      return _.filter(survey.fields_nitrogen_surveys, (function(_this) {
        return function(fieldSurvey) {
          return _this.service.fieldSurveyComplete(fieldSurvey);
        };
      })(this));
    };

    SidebarController.prototype.gotoStep = function(stepName) {
      return this.service.gotoStep(this.service.findStepIndexByName(stepName), this.stateParams.surveyId);
    };

    SidebarController.prototype.showFullpage = function() {
      return this.inNSolverProcess();
    };

    SidebarController.prototype.inNSolverProcess = function() {
      return this.state.includes('grower.nsolver.step');
    };

    SidebarController.prototype.currentStepIs = function(stepName) {
      return stepName === this.service.currentStepName;
    };

    SidebarController.prototype.stepVisited = function(stepName) {
      var ref;
      return ((ref = this.service.survey) != null ? ref.visited_steps.indexOf(stepName) : void 0) !== -1;
    };

    SidebarController.prototype.stepSaved = function(stepName) {
      var ref;
      return ((ref = this.service.survey) != null ? ref.saved_steps.indexOf(stepName) : void 0) !== -1;
    };

    SidebarController.prototype.exitSurvey = function() {
      return this.state.go('grower.nsolver', {}, {
        reload: 'grower.nsolver'
      });
    };

    SidebarController.prototype.seeIfDisableSummaryReport = function() {
      var selectedSurvey;
      selectedSurvey = this.surveyExists();
      if (!selectedSurvey) {
        return;
      }
      return this.http.get("/backend/grower/nsolver/" + selectedSurvey.id + "/count").then(function(response) {
        return response.data;
      }).then((function(_this) {
        return function(counts) {
          _this.scope.disableSummaryReportCheckbox = counts.historical === 0;
          return _this.scope.disableSummaryReportButton = _this.scope.summaryReportHistoricalData ? false : counts.count === 0;
        };
      })(this));
    };

    SidebarController.prototype.createSummaryReport = function() {
      var selectedSurvey;
      selectedSurvey = this.surveyExists();
      this.window.open(("/backend/grower/nsolver/" + selectedSurvey.id + "/report") + (this.scope.summaryReportHistoricalData ? '/historical' : ''));
    };

    return SidebarController;

  })(Controller);

}).call(this);
